// SEO Content: Service-specific landing pages with unique content
// Each service page has 800-1200 words of unique content for Düsseldorf

export const serviceContent = {
  // Innenanstrich - P0 Service
  innenanstrich: {
    duesseldorf: {
      heroTitle: "Innenanstrich Düsseldorf – Wände & Decken professionell streichen",
      heroSubtitle: "Ihr Spezialist für hochwertige Innenanstriche in der Landeshauptstadt. Von der Altbauwohnung bis zum modernen Loft – wir bringen Farbe in Ihr Zuhause.",

      mainContent: {
        intro: `Ein frischer Innenanstrich verwandelt jeden Raum. Ob Sie gerade eingezogen sind, eine Renovierung planen oder einfach neuen Schwung in Ihre vier Wände bringen möchten – professionelle Malerarbeiten machen den Unterschied. In Düsseldorf sind wir als FarbWelt Service Ihr kompetenter Partner für alle Innenanstriche.

Die Landeshauptstadt bietet eine einzigartige Vielfalt an Wohnstilen: von den hohen Stuckdecken in Pempelfort über die modernen Lofts in Flingern bis zu den repräsentativen Villen in Oberkassel. Diese Vielfalt erfordert einen Malerbetrieb, der sich auf unterschiedlichste Anforderungen einstellen kann – und genau das ist unsere Stärke.`,

        expertiseSection: {
          title: "Unser Know-how für Ihren Innenanstrich",
          content: `Innenanstrich ist mehr als Farbe auf die Wand zu bringen. Es beginnt mit der richtigen Vorbereitung: Untergründe müssen geprüft, gereinigt und grundiert werden. Risse werden verspachtelt, unebene Stellen geglättet. Erst wenn der Untergrund perfekt ist, beginnen wir mit dem eigentlichen Anstrich.

Bei der Farbwahl beraten wir Sie kompetent. Welche Farbe passt zu Ihrem Einrichtungsstil? Welche Wirkung möchten Sie erzielen? Soll der Raum größer, gemütlicher oder eleganter wirken? Wir bringen Muster mit und zeigen Ihnen die Wirkung in Ihren eigenen Räumen – denn Farben sehen unter verschiedenen Lichtverhältnissen unterschiedlich aus.

Wir arbeiten ausschließlich mit Premium-Farben namhafter Hersteller wie Caparol, Brillux, Alpina und Dulux. Diese Markenprodukte überzeugen durch hohe Deckkraft, Langlebigkeit und ein angenehmes Raumklima. Für Allergiker und Familien mit Kindern führen wir auch spezielle Öko-Farben, die besonders schadstoffarm sind.`
        },

        processSection: {
          title: "So läuft Ihr Innenanstrich in Düsseldorf ab",
          steps: [
            {
              title: "Kostenlose Beratung vor Ort",
              description: "Wir kommen zu Ihnen, erfassen den Zustand der Wände und Decken und besprechen Ihre Wünsche. Dabei geben wir erste Empfehlungen zu Farben und Techniken."
            },
            {
              title: "Detailliertes Festpreisangebot",
              description: "Sie erhalten ein transparentes Angebot mit allen Einzelleistungen. Der genannte Preis ist verbindlich – keine versteckten Kosten."
            },
            {
              title: "Sorgfältige Vorbereitung",
              description: "Wir schützen Ihre Möbel und Böden mit Folie und Vlies. Steckdosen, Lichtschalter und Fußleisten werden fachgerecht abgeklebt."
            },
            {
              title: "Professionelle Ausführung",
              description: "Unsere Maler arbeiten sauber und präzise. Je nach Untergrund erfolgen Grundierung, Zwischenanstrich und Schlussanstrich."
            },
            {
              title: "Gemeinsame Abnahme",
              description: "Nach Abschluss gehen wir gemeinsam durch die Räume. Kleine Nachbesserungen erledigen wir sofort. Erst wenn Sie zufrieden sind, ist der Auftrag abgeschlossen."
            }
          ]
        },

        specialtiesSection: {
          title: "Besondere Herausforderungen – Unsere Spezialitäten",
          items: [
            {
              title: "Altbauwohnungen mit hohen Decken",
              description: "Die typischen Düsseldorfer Altbauten in Bilk, Pempelfort oder Unterbilk haben oft Deckenhöhen von 3,50 Metern oder mehr. Wir verfügen über spezielle Arbeitsbühnen und Gerüstsysteme, um auch in diesen Höhen präzise zu arbeiten."
            },
            {
              title: "Stuckdecken und Zierleisten",
              description: "Historische Stuckelemente erfordern besondere Sorgfalt. Wir streichen Stuckdecken so, dass die Ornamente zur Geltung kommen, ohne die Details zu verwischen."
            },
            {
              title: "Nikotinbelastete Wände",
              description: "Nach jahrelangem Rauchen sind Wände oft vergilbt und riechen unangenehm. Wir verwenden Sperrgrundierungen, die Nikotin einschließen und dauerhaft isolieren."
            },
            {
              title: "Feuchtigkeitsschäden",
              description: "Vor dem Streichen müssen Feuchtigkeitsprobleme gelöst werden. Wir analysieren die Ursache und verwenden bei Restfeuchtigkeit spezielle Farben, die atmungsaktiv sind."
            }
          ]
        },

        pricingSection: {
          title: "Kosten für Innenanstrich in Düsseldorf",
          content: `Die Kosten für einen Innenanstrich hängen von verschiedenen Faktoren ab: Größe der Fläche, Zustand der Wände, Anzahl der benötigten Anstriche und gewählte Farbqualität. Als Orientierung:

- **Einfacher Dispersionsanstrich** (gut deckend, 2 Anstriche): ca. 8-12 € pro m²
- **Premium-Anstrich** (hochwertige Farben, perfekte Oberfläche): ca. 12-18 € pro m²
- **Akzentwände** mit Farbe oder Effekt: ca. 15-25 € pro m²

Diese Preise verstehen sich inklusive Material, Abdeckarbeiten und Endreinigung. Für ein verbindliches Angebot kommen wir gerne zu Ihnen – die Besichtigung ist kostenlos und unverbindlich.`
        },

        faq: [
          {
            question: "Wie lange dauert ein Innenanstrich in Düsseldorf?",
            answer: "Das hängt von der Größe und dem Zustand ab. Eine 70-m²-Wohnung mit normalem Renovierungsbedarf ist in 2-4 Arbeitstagen fertig. Bei umfangreichen Vorarbeiten wie Tapeten entfernen oder Spachteln entsprechend länger."
          },
          {
            question: "Kann ich während der Arbeiten in der Wohnung bleiben?",
            answer: "Ja, in der Regel ist das möglich. Wir arbeiten Raum für Raum und achten darauf, Ihren Alltag möglichst wenig zu stören. Bei großen Projekten kann es jedoch komfortabler sein, einige Tage auszuweichen."
          },
          {
            question: "Welche Farbe empfehlen Sie für Schlafzimmer?",
            answer: "Für Schlafzimmer empfehlen wir ruhige, gedämpfte Töne wie Blaugrau, Greige oder sanftes Grün. Diese Farben wirken beruhigend und fördern einen guten Schlaf. Gerne beraten wir Sie mit Mustern vor Ort."
          },
          {
            question: "Entfernen Sie auch alte Tapeten vor dem Streichen?",
            answer: "Ja, wir bieten einen Komplett-Service. Das Entfernen alter Tapeten, das Verspachteln von Schäden und das Grundieren gehören zu unserem Leistungsspektrum."
          },
          {
            question: "Arbeiten Sie auch in allen Düsseldorfer Stadtteilen?",
            answer: "Ja, wir sind in ganz Düsseldorf tätig – von Kaiserswerth im Norden bis Benrath im Süden, von Oberkassel im Westen bis Gerresheim im Osten."
          }
        ],

        nearbyDistricts: ["Bilk", "Pempelfort", "Flingern", "Oberkassel", "Unterbilk", "Derendorf"]
      },

      meta: {
        title: "Innenanstrich Düsseldorf | Wände streichen lassen | FarbWelt Service",
        description: "Professioneller Innenanstrich in Düsseldorf ✓ Altbau & Neubau ✓ Premium-Farben ✓ Festpreise. Wände & Decken streichen vom Fachmann. Jetzt Termin buchen!",
        keywords: "Innenanstrich Düsseldorf, Wände streichen Düsseldorf, Decken streichen Düsseldorf, Maler Innenanstrich, Wohnung streichen lassen"
      }
    },
    
    // Innenanstrich Dormagen
    dormagen: {
      heroTitle: "Innenanstrich Dormagen – Wände & Decken vom lokalen Fachbetrieb",
      heroSubtitle: "Professionelle Innenanstriche in Dormagen und allen Ortsteilen. Vom Altbau in Zons bis zum Neubau in Hackenbroich – wir bringen Farbe in Ihr Zuhause.",

      mainContent: {
        intro: `Ein frischer Innenanstrich verwandelt jeden Raum. Ob Sie gerade eingezogen sind, eine Renovierung planen oder einfach neuen Schwung in Ihre vier Wände bringen möchten – professionelle Malerarbeiten machen den Unterschied. Als lokaler Malerbetrieb in Dormagen sind wir Ihr kompetenter Partner für alle Innenanstriche.

Dormagen bietet eine vielfältige Wohnlandschaft: Von den historischen Fachwerkhäusern in Zons über die soliden Siedlungshäuser in Nievenheim bis zu den modernen Neubauten in Hackenbroich. Diese Vielfalt erfordert einen Malerbetrieb, der sich auf unterschiedlichste Anforderungen einstellen kann.`,

        expertiseSection: {
          title: "Lokale Kompetenz für Ihren Innenanstrich",
          content: `Innenanstrich ist mehr als Farbe auf die Wand zu bringen. Es beginnt mit der richtigen Vorbereitung: Untergründe müssen geprüft, gereinigt und grundiert werden. Risse werden verspachtelt, unebene Stellen geglättet.

Als Dormagener Unternehmen kennen wir die Besonderheiten der lokalen Gebäude. Die historischen Häuser in der Zollfeste Zons erfordern sensibles Vorgehen. Die Nachkriegsbauten in Nievenheim und Horrem haben ihre eigenen Herausforderungen. Wir arbeiten mit Premium-Farben namhafter Hersteller wie Caparol, Brillux und Alpina.`
        },

        processSection: {
          title: "So läuft Ihr Innenanstrich in Dormagen ab",
          steps: [
            { title: "Kostenlose Beratung vor Ort", description: "Wir kommen zu Ihnen nach Hause und besprechen Ihre Farbwünsche." },
            { title: "Detailliertes Festpreisangebot", description: "Sie erhalten ein transparentes Angebot. Der genannte Preis ist verbindlich." },
            { title: "Sorgfältige Vorbereitung", description: "Wir schützen Ihre Möbel und Böden sorgfältig." },
            { title: "Professionelle Ausführung", description: "Unsere Maler arbeiten sauber und präzise." },
            { title: "Gemeinsame Abnahme", description: "Erst wenn Sie zufrieden sind, ist der Auftrag abgeschlossen." }
          ]
        },

        specialtiesSection: {
          title: "Besondere Herausforderungen – Unsere Stärken",
          items: [
            { title: "Historische Gebäude in Zons", description: "Denkmalgeschützte Häuser erfordern mineralische Farben." },
            { title: "Keller und Souterrains", description: "Atmungsaktive Farben gegen Feuchtigkeit." },
            { title: "Neubauten", description: "Schadstoffarme Farben für Familien." },
            { title: "Raucherwohnungen", description: "Sperrgrundierungen gegen Nikotin." }
          ]
        },

        pricingSection: {
          title: "Kosten für Innenanstrich in Dormagen",
          content: `Orientierungspreise:
- Einfacher Dispersionsanstrich: ca. 8-12 € pro m²
- Premium-Anstrich: ca. 12-16 € pro m²
- Akzentwände: ca. 14-22 € pro m²
Keine Anfahrtskosten in Dormagen!`
        }
      },

      faq: [
        { question: "Berechnen Sie Anfahrtskosten in Dormagen?", answer: "Nein, für Dormagen und alle Ortsteile berechnen wir keine Anfahrtskosten." },
        { question: "Arbeiten Sie in allen Ortsteilen?", answer: "Ja – Nievenheim, Zons, Horrem, Hackenbroich, Stürzelberg, Straberg und alle weiteren." },
        { question: "Wie lange dauert ein Innenanstrich?", answer: "Eine 70-m²-Wohnung ist in 2-4 Arbeitstagen fertig." }
      ],

      meta: {
        title: "Innenanstrich Dormagen | Wände streichen | FarbWelt Service",
        description: "Professioneller Innenanstrich in Dormagen ✓ Alle Ortsteile ✓ Festpreise ✓ Lokaler Betrieb. Jetzt Termin buchen!",
        keywords: "Innenanstrich Dormagen, Wände streichen Dormagen, Maler Dormagen"
      }
    },
    
    // Innenanstrich Köln
    koeln: {
      heroTitle: "Innenanstrich Köln – Wände & Decken in der Domstadt",
      heroSubtitle: "Professionelle Innenanstriche für alle Kölner Stadtteile. Vom Belgischen Viertel bis Chorweiler – wir bringen Farbe in Ihr Zuhause.",

      mainContent: {
        intro: `Ein frischer Innenanstrich verwandelt jeden Raum. Ob Altbauwohnung in der Südstadt, Villa in Lindenthal oder moderne Wohnung in Deutz – professionelle Malerarbeiten machen den Unterschied. Als Malerbetrieb in Köln sind wir Ihr kompetenter Partner.

Die Domstadt bietet eine einzigartige Vielfalt an Wohnungen: Gründerzeitvillen mit Stuck, umgebaute Industrielofts, moderne Apartments. Diese Vielfalt erfordert einen Malerbetrieb, der sich auf unterschiedlichste Anforderungen einstellen kann.`,

        expertiseSection: {
          title: "Lokale Kompetenz für Ihren Innenanstrich",
          content: `Als Kölner Betrieb kennen wir die Besonderheiten der lokalen Gebäude. Die prächtigen Altbauten im Belgischen Viertel und der Südstadt erfordern sensibles Vorgehen. Die Hochhäuser in Chorweiler haben andere Anforderungen. Wir arbeiten mit Premium-Farben namhafter Hersteller wie Caparol, Brillux und Alpina.`
        },

        processSection: {
          title: "So läuft Ihr Innenanstrich in Köln ab",
          steps: [
            { title: "Kostenlose Beratung vor Ort", description: "Wir kommen zu Ihnen und besprechen Ihre Farbwünsche." },
            { title: "Detailliertes Festpreisangebot", description: "Transparentes Angebot ohne versteckte Kosten." },
            { title: "Sorgfältige Vorbereitung", description: "Möbel und Böden werden professionell geschützt." },
            { title: "Professionelle Ausführung", description: "Saubere, präzise Arbeit unserer erfahrenen Maler." },
            { title: "Gemeinsame Abnahme", description: "Erst wenn Sie zufrieden sind, ist der Auftrag erledigt." }
          ]
        },

        pricingSection: {
          title: "Kosten für Innenanstrich in Köln",
          content: `Orientierungspreise:
- Einfacher Dispersionsanstrich: ca. 8-12 € pro m²
- Premium-Anstrich: ca. 12-16 € pro m²
- Akzentwände: ca. 14-22 € pro m²
Keine Anfahrtskosten in ganz Köln!`
        }
      },

      faq: [
        { question: "Berechnen Sie Anfahrtskosten in Köln?", answer: "Nein, für alle Kölner Stadtteile berechnen wir keine Anfahrtskosten." },
        { question: "In welchen Stadtteilen sind Sie tätig?", answer: "In ganz Köln – von Chorweiler bis Porz, von Ehrenfeld bis Kalk." },
        { question: "Wie lange dauert ein Innenanstrich?", answer: "Eine 70-m²-Wohnung ist in 2-4 Arbeitstagen fertig." }
      ],

      meta: {
        title: "Innenanstrich Köln | Wände streichen | FarbWelt Service",
        description: "Professioneller Innenanstrich in Köln ✓ Alle Stadtteile ✓ Festpreise ✓ Lokaler Betrieb. Jetzt Termin buchen!",
        keywords: "Innenanstrich Köln, Wände streichen Köln, Maler Köln Innenanstrich"
      }
    },
    
    // Innenanstrich Leverkusen
    leverkusen: {
      heroTitle: "Innenanstrich Leverkusen – Wände & Decken vom Fachmann",
      heroSubtitle: "Professionelle Innenanstriche für alle Leverkusener Stadtteile. Von Wiesdorf bis Opladen – wir bringen Farbe in Ihr Zuhause.",
      mainContent: {
        intro: `Ein frischer Innenanstrich verwandelt jeden Raum. Als Malerbetrieb in Leverkusen sind wir Ihr kompetenter Partner – ob Wohnung in Wiesdorf, Altbau in Opladen oder Eigenheim in Schlebusch.`,
        expertiseSection: { title: "Lokale Kompetenz", content: `Wir kennen Leverkusen und seine Stadtteile. Jedes Gebäude hat seine Anforderungen – wir haben die passenden Lösungen und verwenden nur Premium-Farben.` },
        processSection: { title: "Unser Ablauf", steps: [
          { title: "Beratung", description: "Kostenlos vor Ort" },
          { title: "Angebot", description: "Transparent und verbindlich" },
          { title: "Ausführung", description: "Sauber und pünktlich" }
        ]},
        pricingSection: { title: "Preise", content: `Orientierung: 8-16 € pro m². Keine Anfahrtskosten in Leverkusen!` }
      },
      faq: [{ question: "Anfahrtskosten?", answer: "Keine in ganz Leverkusen." }],
      meta: { title: "Innenanstrich Leverkusen | FarbWelt Service", description: "Innenanstrich in Leverkusen ✓ Alle Stadtteile ✓ Festpreise.", keywords: "Innenanstrich Leverkusen" }
    },
    
    // Innenanstrich Monheim
    monheim: {
      heroTitle: "Innenanstrich Monheim – Wände & Decken am Rhein",
      heroSubtitle: "Professionelle Innenanstriche in Monheim am Rhein. Für Monheim-Mitte und Baumberg.",
      mainContent: {
        intro: `Monheim am Rhein wächst – und wir wachsen mit. Ob Neubau oder Bestand, wir streichen Ihre Wände professionell und sauber.`,
        expertiseSection: { title: "Lokale Kompetenz", content: `Wir kennen Monheim und seine Besonderheiten. Premium-Farben und saubere Arbeit sind selbstverständlich.` },
        pricingSection: { title: "Preise", content: `Orientierung: 8-16 € pro m². Keine Anfahrtskosten!` }
      },
      faq: [{ question: "Anfahrtskosten?", answer: "Keine in Monheim." }],
      meta: { title: "Innenanstrich Monheim | FarbWelt Service", description: "Innenanstrich in Monheim ✓ Festpreise.", keywords: "Innenanstrich Monheim" }
    }
  },

  // Fassadenarbeiten - P0 Service
  fassadenarbeiten: {
    duesseldorf: {
      heroTitle: "Fassadenarbeiten Düsseldorf – Schutz & Schönheit für Ihr Haus",
      heroSubtitle: "Professionelle Fassadenanstriche, Fassadensanierung und Wärmedämmung. Wir schützen Ihr Gebäude und verleihen ihm neuen Glanz.",

      mainContent: {
        intro: `Die Fassade ist das Gesicht Ihres Hauses – und gleichzeitig der wichtigste Schutzschild gegen Witterungseinflüsse. In Düsseldorf, wo das feuchte Rheinlandklima Fassaden besonders beansprucht, ist professionelle Fassadenpflege keine Option, sondern eine Notwendigkeit.

Als erfahrener Malerbetrieb haben wir in Düsseldorf bereits hunderte Fassaden gestrichen, saniert und geschützt. Von der denkmalgeschützten Villa in Kaiserswerth über das Mehrfamilienhaus in Bilk bis zum modernen Geschäftsgebäude im Medienhafen – wir kennen die Anforderungen unterschiedlichster Fassadentypen.`,

        expertiseSection: {
          title: "Fassaden-Kompetenz für Düsseldorf",
          content: `Das Düsseldorfer Klima stellt hohe Anforderungen an Fassaden. Die Nähe zum Rhein bringt hohe Luftfeuchtigkeit, die Westwinde treiben Regen gegen die Hauswände, und die Temperaturschwankungen zwischen Sommer und Winter belasten jeden Anstrich. Wir kennen diese Bedingungen und setzen entsprechend robuste Materialien ein.

Unsere Fassadenfarben sind speziell für das rheinische Klima ausgewählt: hochelastisch, um Temperaturschwankungen aufzufangen; diffusionsoffen, damit Feuchtigkeit entweichen kann; und mit fungiziden Zusätzen gegen Algen- und Pilzbefall. Die Kombination aus hochwertigen Materialien und fachgerechter Verarbeitung garantiert ein Ergebnis, das viele Jahre hält.

Besondere Expertise haben wir bei historischen Fassaden. Viele Düsseldorfer Gebäude stehen unter Denkmalschutz oder in Erhaltungssatzungen. Hier verwenden wir mineralische Farben und historisch korrekte Techniken, die den Charakter des Gebäudes bewahren und gleichzeitig modernen Schutz bieten.`
        },

        servicesSection: {
          title: "Unser Fassaden-Leistungsspektrum",
          items: [
            {
              title: "Fassadenanstrich",
              description: "Klassischer Neuanstrich mit hochwertigen Silikonharz- oder Silikatfarben. Inklusive Reinigung, Grundierung und zweifachem Schlussanstrich."
            },
            {
              title: "Fassadensanierung",
              description: "Umfassende Instandsetzung geschädigter Fassaden: Rissesanierung, Putzausbesserung, Behandlung von Feuchtigkeitsschäden."
            },
            {
              title: "Wärmedämmverbundsystem (WDVS)",
              description: "Energetische Sanierung mit modernen Dämmsystemen. Spart Heizkosten und verbessert das Raumklima."
            },
            {
              title: "Sockelanstrich",
              description: "Der Sockel ist besonders beansprucht. Wir verwenden spezielle Sockelfarben, die wasserabweisend und mechanisch belastbar sind."
            },
            {
              title: "Algensanierung",
              description: "Behandlung von Algen- und Pilzbefall mit professionellen Mitteln und anschließendem Schutzanstrich."
            },
            {
              title: "Denkmalschutz-Fassaden",
              description: "Fachgerechte Sanierung historischer Fassaden mit zugelassenen Materialien und in Abstimmung mit Behörden."
            }
          ]
        },

        processSection: {
          title: "Ablauf einer Fassadenarbeit",
          steps: [
            {
              title: "Bestandsaufnahme",
              description: "Wir begutachten die Fassade, dokumentieren Schäden und klären die statischen Gegebenheiten für das Gerüst."
            },
            {
              title: "Angebot & Planung",
              description: "Sie erhalten ein detailliertes Angebot mit Materialspezifikation. Bei denkmalgeschützten Gebäuden klären wir Auflagen."
            },
            {
              title: "Gerüstbau",
              description: "Wir beauftragen ein Gerüstbauunternehmen oder stellen eigene Gerüste. Gehwege werden ggf. gesichert."
            },
            {
              title: "Untergrundvorbereitung",
              description: "Hochdruckreinigung, Reparatur von Schäden, Grundierung – die Basis für ein langlebiges Ergebnis."
            },
            {
              title: "Anstrich",
              description: "Professioneller Fassadenanstrich in zwei bis drei Arbeitsgängen, je nach Anforderung."
            },
            {
              title: "Abnahme & Dokumentation",
              description: "Gemeinsame Abnahme, Übergabe der Dokumentation mit verwendeten Materialien und Pflegehinweisen."
            }
          ]
        },

        pricingSection: {
          title: "Kosten für Fassadenarbeiten in Düsseldorf",
          content: `Die Kosten für Fassadenarbeiten variieren stark je nach Größe, Zustand und gewähltem System:

- **Fassadenanstrich** (gut erhaltene Fassade): ca. 20-35 € pro m²
- **Fassadensanierung** (mit Putzarbeiten): ca. 40-60 € pro m²
- **WDVS (Wärmedämmung)**: ca. 120-180 € pro m², je nach Dämmstärke

Für ein Einfamilienhaus mit ca. 150 m² Fassadenfläche rechnen Sie für einen Anstrich mit etwa 4.000-7.000 Euro. Die genauen Kosten ermitteln wir gerne bei einer kostenlosen Vor-Ort-Besichtigung.`
        },

        faq: [
          {
            question: "Wie oft sollte eine Fassade in Düsseldorf gestrichen werden?",
            answer: "Bei hochwertiger Arbeit hält ein Fassadenanstrich in Düsseldorf 15-20 Jahre. Faktoren wie Himmelsrichtung (Westseiten sind stärker belastet), Bepflanzung und Luftverschmutzung beeinflussen die Lebensdauer."
          },
          {
            question: "Wann ist die beste Jahreszeit für Fassadenarbeiten?",
            answer: "Ideal sind Frühjahr und Herbst mit moderaten Temperaturen (10-25°C) und wenig Niederschlag. Im Hochsommer können zu hohe Temperaturen, im Winter Frost die Arbeit behindern."
          },
          {
            question: "Brauche ich eine Genehmigung für Fassadenarbeiten in Düsseldorf?",
            answer: "Für einen Anstrich in der bisherigen Farbe meist nicht. Bei Farbänderungen, denkmalgeschützten Gebäuden oder Gebäuden in Erhaltungssatzungen ist eine Abstimmung mit der Stadt erforderlich. Wir beraten Sie gerne."
          },
          {
            question: "Können Sie auch bei leichtem Regen arbeiten?",
            answer: "Nein, Fassadenanstriche erfordern trockene Bedingungen. Bei Regen unterbrechen wir die Arbeit, um Qualitätsprobleme zu vermeiden. Deshalb planen wir immer Puffertage ein."
          },
          {
            question: "Schützen Sie meine Pflanzen und den Garten?",
            answer: "Selbstverständlich. Wir decken empfindliche Pflanzen ab und positionieren Gerüste so, dass Schäden minimiert werden. Nach den Arbeiten ist von unserem Einsatz nichts mehr zu sehen."
          }
        ],

        nearbyDistricts: ["Benrath", "Kaiserswerth", "Oberkassel", "Gerresheim", "Stockum", "Wersten"]
      },

      meta: {
        title: "Fassadenarbeiten Düsseldorf | Fassadenanstrich & Sanierung | FarbWelt",
        description: "Professionelle Fassadenarbeiten in Düsseldorf ✓ Anstrich ✓ Sanierung ✓ WDVS ✓ Denkmalschutz. Schutz & Schönheit für Ihr Haus. Jetzt beraten lassen!",
        keywords: "Fassadenarbeiten Düsseldorf, Fassadenanstrich Düsseldorf, Fassadensanierung Düsseldorf, Hausfassade streichen, WDVS Düsseldorf"
      }
    },
    
    // Fassadenarbeiten Dormagen
    dormagen: {
      heroTitle: "Fassadenarbeiten Dormagen – Schutz & Schönheit für Ihr Haus",
      heroSubtitle: "Professionelle Fassadenanstriche und Fassadensanierung. Wir schützen Ihr Gebäude vor dem rheinischen Klima.",

      mainContent: {
        intro: `Die Fassade ist das Gesicht Ihres Hauses und der wichtigste Schutzschild gegen Witterungseinflüsse. In Dormagen, wo das feuchte Rheinlandklima Fassaden beansprucht, ist professionelle Fassadenpflege eine Investition in den Werterhalt.

Als lokaler Malerbetrieb haben wir in Dormagen bereits hunderte Fassaden gestrichen und saniert. Von den denkmalgeschützten Häusern in Zons über die Einfamilienhäuser in Horrem bis zu den Mehrfamilienhäusern in Nievenheim – wir kennen die Anforderungen.`,

        expertiseSection: {
          title: "Fassaden-Kompetenz für Dormagen",
          content: `Das Dormagener Klima stellt hohe Anforderungen. Die Nähe zum Rhein bringt hohe Luftfeuchtigkeit. Besonders in Stürzelberg und Rheinfeld sind Fassaden stark belastet. Wir setzen robuste Materialien ein: hochelastische, diffusionsoffene Farben mit fungiziden Zusätzen.

Besondere Expertise haben wir bei den historischen Fassaden in Zons. Die denkmalgeschützten Gebäude erfordern mineralische Farben und traditionelle Techniken.`
        },

        servicesSection: {
          title: "Unser Fassaden-Leistungsspektrum",
          items: [
            { title: "Fassadenanstrich", description: "Neuanstrich mit hochwertigen Silikonharz- oder Silikatfarben." },
            { title: "Fassadensanierung", description: "Rissesanierung, Putzausbesserung, Feuchtigkeitsbehandlung." },
            { title: "Sockelanstrich", description: "Wasserabweisende und mechanisch belastbare Sockelfarben." },
            { title: "Algensanierung", description: "Professionelle Behandlung mit Schutzanstrich." },
            { title: "Denkmalschutz Zons", description: "Fachgerechte Sanierung mit zugelassenen Materialien." },
            { title: "Wärmedämmung (WDVS)", description: "Energetische Sanierung für niedrigere Heizkosten." }
          ]
        },

        pricingSection: {
          title: "Kosten für Fassadenarbeiten in Dormagen",
          content: `Orientierungspreise:
- Fassadenanstrich: ca. 18-32 € pro m²
- Fassadensanierung: ca. 35-55 € pro m²
- WDVS: ca. 110-160 € pro m²
Einfamilienhaus (ca. 140 m²): ca. 3.500-6.000 Euro für Anstrich.`
        }
      },

      faq: [
        { question: "Wie oft sollte eine Fassade gestrichen werden?", answer: "Bei hochwertiger Arbeit 15-20 Jahre. In Rheinnähe kann die Belastung höher sein." },
        { question: "Brauche ich eine Genehmigung?", answer: "Für Anstrich meist nicht. In Zons und bei Farbänderungen ist Abstimmung erforderlich." },
        { question: "Kennen Sie sich mit Denkmalschutz in Zons aus?", answer: "Ja, wir haben dort bereits mehrere Projekte durchgeführt." }
      ],

      meta: {
        title: "Fassadenarbeiten Dormagen | Fassadenanstrich & Sanierung | FarbWelt",
        description: "Professionelle Fassadenarbeiten in Dormagen ✓ Anstrich ✓ Sanierung ✓ Denkmalschutz Zons. Jetzt beraten lassen!",
        keywords: "Fassadenarbeiten Dormagen, Fassadenanstrich Dormagen, Fassade streichen Dormagen"
      }
    },
    
    // Fassadenarbeiten Köln
    koeln: {
      heroTitle: "Fassadenarbeiten Köln – Schutz & Schönheit für Ihr Haus",
      heroSubtitle: "Professionelle Fassadenanstriche in der Domstadt. Wir schützen Ihr Gebäude vor dem rheinischen Klima.",

      mainContent: {
        intro: `Die Fassade ist das Gesicht Ihres Hauses und der wichtigste Schutzschild gegen Witterungseinflüsse. In Köln, wo das feuchte Rheinlandklima Fassaden beansprucht, ist professionelle Fassadenpflege eine Investition in den Werterhalt.

Als Malerbetrieb haben wir in Köln hunderte Fassaden gestrichen und saniert. Von den Gründerzeitvillen in Lindenthal über die Mehrfamilienhäuser in Nippes bis zu den modernen Bauten im Rheinauhafen – wir kennen die Anforderungen.`,

        expertiseSection: {
          title: "Fassaden-Kompetenz für Köln",
          content: `Das Kölner Klima stellt hohe Anforderungen. Die Nähe zum Rhein bringt Feuchtigkeit. Wir setzen robuste Materialien ein: hochelastische, diffusionsoffene Farben mit fungiziden Zusätzen.

Besondere Expertise haben wir bei historischen Fassaden. Die denkmalgeschützten Gebäude in der Altstadt und im Belgischen Viertel erfordern mineralische Farben und traditionelle Techniken.`
        },

        servicesSection: {
          title: "Unser Fassaden-Leistungsspektrum",
          items: [
            { title: "Fassadenanstrich", description: "Neuanstrich mit Silikonharz- oder Silikatfarben." },
            { title: "Fassadensanierung", description: "Rissesanierung, Putzausbesserung, Feuchtigkeitsbehandlung." },
            { title: "Denkmalschutz", description: "Fachgerechte Sanierung mit zugelassenen Materialien." },
            { title: "Wärmedämmung (WDVS)", description: "Energetische Sanierung für niedrigere Heizkosten." }
          ]
        },

        pricingSection: {
          title: "Kosten für Fassadenarbeiten in Köln",
          content: `Orientierungspreise:
- Fassadenanstrich: ca. 18-32 € pro m²
- Fassadensanierung: ca. 35-55 € pro m²
- WDVS: ca. 110-160 € pro m²`
        }
      },

      faq: [
        { question: "Wie oft sollte eine Fassade gestrichen werden?", answer: "Bei hochwertiger Arbeit 15-20 Jahre. In Rheinnähe kann die Belastung höher sein." },
        { question: "Arbeiten Sie auch mit Denkmalschutz?", answer: "Ja, wir haben Erfahrung mit den Auflagen in der Altstadt und dem Belgischen Viertel." }
      ],

      meta: {
        title: "Fassadenarbeiten Köln | Fassadenanstrich & Sanierung | FarbWelt",
        description: "Professionelle Fassadenarbeiten in Köln ✓ Anstrich ✓ Sanierung ✓ Denkmalschutz. Jetzt beraten lassen!",
        keywords: "Fassadenarbeiten Köln, Fassadenanstrich Köln, Fassade streichen Köln"
      }
    },
    
    // Fassadenarbeiten Leverkusen
    leverkusen: {
      heroTitle: "Fassadenarbeiten Leverkusen – Schutz für Ihr Haus",
      heroSubtitle: "Professionelle Fassadenanstriche in Leverkusen. Wir schützen Ihr Gebäude vor dem Rheinlandklima.",
      mainContent: {
        intro: `Die Fassade ist Schutzschild und Visitenkarte zugleich. In Leverkusen, wo Rhein und Chemieumfeld besondere Anforderungen stellen, ist professioneller Fassadenschutz wichtig.`,
        expertiseSection: { title: "Lokale Kompetenz", content: `Wir kennen die Leverkusener Bedingungen und verwenden entsprechend robuste Materialien.` },
        pricingSection: { title: "Preise", content: `Fassadenanstrich: ca. 18-32 € pro m². Einfamilienhaus: ca. 3.500-6.000 €.` }
      },
      faq: [{ question: "Wie oft Fassade streichen?", answer: "Bei guter Arbeit 15-20 Jahre." }],
      meta: { title: "Fassadenarbeiten Leverkusen | FarbWelt Service", description: "Fassadenarbeiten in Leverkusen ✓ Schutz ✓ Qualität.", keywords: "Fassadenarbeiten Leverkusen" }
    },
    
    // Fassadenarbeiten Monheim
    monheim: {
      heroTitle: "Fassadenarbeiten Monheim – Schutz am Rhein",
      heroSubtitle: "Professionelle Fassadenanstriche in Monheim am Rhein. Feuchtigkeitsschutz für Ihre Immobilie.",
      mainContent: {
        intro: `Die Rheinlage von Monheim stellt besondere Anforderungen an Fassaden. Wir verwenden feuchtigkeitsbeständige Materialien für langlebigen Schutz.`,
        pricingSection: { title: "Preise", content: `Fassadenanstrich: ca. 18-32 € pro m².` }
      },
      faq: [{ question: "Rhein-Feuchtigkeit?", answer: "Wir verwenden spezielle, feuchtigkeitsbeständige Materialien." }],
      meta: { title: "Fassadenarbeiten Monheim | FarbWelt Service", description: "Fassadenarbeiten in Monheim ✓ Rheinlage ✓ Schutz.", keywords: "Fassadenarbeiten Monheim" }
    }
  },

  // Tapezierarbeiten - P0 Service
  tapezierarbeiten: {
    duesseldorf: {
      heroTitle: "Tapezierarbeiten Düsseldorf – Professionell & Blasenfrei",
      heroSubtitle: "Von klassischer Raufaser bis zur Designertapete – wir tapezieren Ihre Räume sauber, präzise und mit Liebe zum Detail.",

      mainContent: {
        intro: `Tapeten verleihen Räumen Charakter und Atmosphäre. Ob zeitlose Raufaser, elegante Vliestapete oder auffällige Mustertapete – professionell tapezierte Wände machen den Unterschied zwischen einer Wohnung und einem Zuhause. In Düsseldorf sind wir als FarbWelt Service Ihr Experte für alle Tapezierarbeiten.

Die Landeshauptstadt bietet Raum für jeden Geschmack. In den großzügigen Altbauwohnungen von Bilk oder Pempelfort kommen edle Tapeten besonders gut zur Geltung. Die hohen Decken und die klassische Architektur bilden den perfekten Rahmen für traditionelle oder moderne Tapetendesigns.`,

        expertiseSection: {
          title: "Tapezier-Kompetenz für Düsseldorf",
          content: `Professionelles Tapezieren ist ein Handwerk, das Erfahrung und Präzision erfordert. Es beginnt mit der richtigen Vorbereitung: Alte Tapeten müssen vollständig entfernt, der Untergrund geprüft und vorbereitet werden. Unebenheiten werden gespachtelt, stark saugende Untergründe grundiert.

Bei der Verarbeitung kommt es auf Details an: Die Tapetenbahnen müssen exakt lotrecht ausgerichtet sein, Muster müssen nahtlos ineinander übergehen, Ecken und Kanten sauber eingearbeitet werden. Besonders bei hochwertigen Mustertapeten ist millimetergenaues Arbeiten Pflicht – jede Ungenauigkeit fällt sofort ins Auge.

Die Düsseldorfer Altbauten stellen besondere Anforderungen. Die oft unebenen Wände, die verwinkelten Raumaufteilungen und die hohen Decken erfordern erfahrene Handwerker. Wir haben in solchen Räumen bereits hunderte Tapezierarbeiten erfolgreich durchgeführt und kennen die typischen Herausforderungen.`
        },

        tapetenTypen: {
          title: "Tapetenarten im Überblick",
          items: [
            {
              title: "Raufasertapete",
              description: "Der Klassiker unter den Tapeten. Robust, überstreichbar und kostengünstig. Ideal für alle, die flexibel bleiben möchten."
            },
            {
              title: "Vliestapete",
              description: "Modern und praktisch. Das Vlies wird direkt an die Wand gekleistert, die Tapete trocken eingelegt. Blasenfreies Ergebnis garantiert."
            },
            {
              title: "Papiertapete",
              description: "Klassisch und umweltfreundlich. Erfordert sorgfältiges Einweichen und schnelles Arbeiten. Nichts für Anfänger."
            },
            {
              title: "Mustertapete",
              description: "Mit Motiven, Streifen oder geometrischen Mustern. Erfordert exakte Rapport-Berechnung für nahtlose Übergänge."
            },
            {
              title: "Strukturtapete",
              description: "Dreidimensionale Oberflächen für spannende Lichteffekte. Von dezent bis auffällig – große Wirkung an Akzentwänden."
            },
            {
              title: "Fototapete",
              description: "Großformatige Motive für besondere Akzente. Moderne Digitaldrucke ermöglichen individuelle Designs."
            }
          ]
        },

        processSection: {
          title: "So läuft Ihre Tapezierung ab",
          steps: [
            {
              title: "Beratung & Auswahl",
              description: "Wir beraten Sie zu Tapetenarten und helfen bei der Auswahl. Auf Wunsch bringen wir Muster mit oder begleiten Sie ins Fachgeschäft."
            },
            {
              title: "Vorbereitung",
              description: "Entfernung alter Tapeten, Untergrundprüfung, Spachtelarbeiten und Grundierung – die Basis für ein perfektes Ergebnis."
            },
            {
              title: "Tapezierung",
              description: "Professionelles Anbringen der Tapeten mit präziser Ausrichtung, sauberen Kanten und blasenfreien Oberflächen."
            },
            {
              title: "Nacharbeiten",
              description: "Bei Raufaser: Anstrich in der gewünschten Farbe. Bei anderen Tapeten: Kontrolle und eventuelle Nachbesserungen."
            }
          ]
        },

        pricingSection: {
          title: "Kosten für Tapezierarbeiten in Düsseldorf",
          content: `Die Kosten hängen von Tapetenart, Raumgröße und Aufwand ab:

- **Raufaser tapezieren + streichen**: ca. 15-22 € pro m² Wandfläche
- **Vliestapete**: ca. 18-28 € pro m², je nach Qualität
- **Mustertapete**: ca. 25-40 € pro m², durch höheren Verschnitt
- **Alte Tapete entfernen**: ca. 5-10 € pro m² zusätzlich

Für eine 70-m²-Wohnung mit ca. 180 m² Wandfläche rechnen Sie für Raufaser-Komplett (Entfernen, Tapezieren, Streichen) mit etwa 4.000-5.500 Euro.`
        },

        faq: [
          {
            question: "Wie lange hält eine Raufasertapete?",
            answer: "Bei guter Qualität und fachgerechter Verarbeitung hält Raufaser 15-20 Jahre. Sie kann mehrfach überstrichen werden, ohne an Struktur zu verlieren."
          },
          {
            question: "Was ist besser: Vliestapete oder Papiertapete?",
            answer: "Vliestapeten sind einfacher zu verarbeiten, dimensionsstabiler und leichter zu entfernen. Papiertapeten sind umweltfreundlicher und günstiger, aber anspruchsvoller in der Verarbeitung."
          },
          {
            question: "Können Sie auch an hohen Decken tapezieren?",
            answer: "Ja, hohe Decken sind unsere Spezialität. Wir verwenden professionelle Arbeitsbühnen und haben Erfahrung mit den typischen 3,50-m-Decken in Düsseldorfer Altbauten."
          },
          {
            question: "Muss die alte Tapete immer runter?",
            answer: "In den meisten Fällen ja. Nur gut haftende Raufaser kann unter Umständen überstrichen werden. Bei mehreren Tapetenschichten oder schadhafter alter Tapete muss abgelöst werden."
          },
          {
            question: "Wie lange muss frische Tapete trocknen?",
            answer: "Je nach Tapetenart und Raumklima 24-48 Stunden. In dieser Zeit sollte nicht zu stark gelüftet werden, um ein Verziehen der Tapete zu vermeiden."
          }
        ],

        nearbyDistricts: ["Pempelfort", "Bilk", "Flingern", "Oberkassel", "Unterbilk", "Carlstadt"]
      },

      meta: {
        title: "Tapezierarbeiten Düsseldorf | Raufaser & Vliestapete | FarbWelt",
        description: "Professionelle Tapezierarbeiten in Düsseldorf ✓ Raufaser ✓ Vliestapete ✓ Mustertapete ✓ Blasenfrei. Tapezieren vom Fachmann. Jetzt Termin buchen!",
        keywords: "Tapezierarbeiten Düsseldorf, Tapezieren Düsseldorf, Raufaser Düsseldorf, Vliestapete, Tapete entfernen"
      }
    },
    
    // Tapezierarbeiten Dormagen
    dormagen: {
      heroTitle: "Tapezierarbeiten Dormagen – Professionell & Sauber",
      heroSubtitle: "Von klassischer Raufaser bis zur Designertapete – wir tapezieren Ihre Räume mit Liebe zum Detail.",

      mainContent: {
        intro: `Tapeten verleihen Räumen Charakter. Ob zeitlose Raufaser, praktische Vliestapete oder auffällige Mustertapete – professionell tapezierte Wände machen den Unterschied. Als lokaler Malerbetrieb in Dormagen sind wir Ihr Experte.

Die Dormagener Wohnlandschaft bietet Raum für jeden Geschmack. In älteren Häusern von Nievenheim kommen klassische Tapeten zur Geltung. In den Neubauten sind moderne Vliestapeten beliebt. Und in Zons braucht es manchmal besondere Lösungen.`,

        expertiseSection: {
          title: "Tapezier-Kompetenz für Dormagen",
          content: `Professionelles Tapezieren erfordert Erfahrung. Es beginnt mit der Vorbereitung: Alte Tapeten vollständig entfernen, Untergrund prüfen, Unebenheiten spachteln.

Bei der Verarbeitung kommt es auf Details an: Exakt lotrecht ausgerichtet, Muster nahtlos, Ecken sauber. Als Dormagener Betrieb kennen wir die typischen Gegebenheiten.`
        },

        tapetenTypen: {
          title: "Tapetenarten im Überblick",
          items: [
            { title: "Raufasertapete", description: "Der Klassiker: Robust und überstreichbar." },
            { title: "Vliestapete", description: "Modern und praktisch, schnelles Tapezieren." },
            { title: "Papiertapete", description: "Klassisch und umweltfreundlich." },
            { title: "Mustertapete", description: "Mit Motiven oder Streifen." },
            { title: "Strukturtapete", description: "3D-Oberflächen für spannende Effekte." }
          ]
        },

        pricingSection: {
          title: "Kosten für Tapezierarbeiten in Dormagen",
          content: `Orientierungspreise:
- Raufaser tapezieren + streichen: ca. 14-20 € pro m²
- Vliestapete: ca. 16-25 € pro m²
- Mustertapete: ca. 22-35 € pro m²
- Alte Tapete entfernen: ca. 4-8 € pro m² zusätzlich`
        }
      },

      faq: [
        { question: "Wie lange hält Raufasertapete?", answer: "15-20 Jahre bei guter Verarbeitung, mehrfach überstreichbar." },
        { question: "Was ist besser: Vlies- oder Papiertapete?", answer: "Vliestapeten sind einfacher, Papiertapeten umweltfreundlicher." },
        { question: "Muss die alte Tapete immer runter?", answer: "In den meisten Fällen ja." }
      ],

      meta: {
        title: "Tapezierarbeiten Dormagen | Raufaser & Vliestapete | FarbWelt",
        description: "Professionelle Tapezierarbeiten in Dormagen ✓ Raufaser ✓ Vliestapete ✓ Blasenfrei. Jetzt Termin buchen!",
        keywords: "Tapezierarbeiten Dormagen, Tapezieren Dormagen, Raufaser Dormagen"
      }
    },
    
    // Tapezierarbeiten Köln
    koeln: {
      heroTitle: "Tapezierarbeiten Köln – Professionell & Sauber",
      heroSubtitle: "Von klassischer Raufaser bis zur Designertapete – wir tapezieren Ihre Räume in der Domstadt mit Liebe zum Detail.",

      mainContent: {
        intro: `Tapeten verleihen Räumen Charakter. Ob zeitlose Raufaser, praktische Vliestapete oder auffällige Mustertapete – professionell tapezierte Wände machen den Unterschied. Als Malerbetrieb in Köln sind wir Ihr Experte.

Die Kölner Wohnlandschaft bietet Raum für jeden Geschmack. In den Altbauten der Südstadt und des Belgischen Viertels kommen edle Tapeten besonders gut zur Geltung.`,

        expertiseSection: {
          title: "Tapezier-Kompetenz für Köln",
          content: `Professionelles Tapezieren erfordert Erfahrung. Es beginnt mit der Vorbereitung: Alte Tapeten entfernen, Untergrund prüfen, Unebenheiten spachteln.

Bei der Verarbeitung kommt es auf Details an: Exakt lotrecht ausgerichtet, Muster nahtlos, Ecken sauber. Als Kölner Betrieb kennen wir die typischen Gegebenheiten der verschiedenen Stadtteile.`
        },

        tapetenTypen: {
          title: "Tapetenarten im Überblick",
          items: [
            { title: "Raufasertapete", description: "Der Klassiker: Robust und überstreichbar." },
            { title: "Vliestapete", description: "Modern und praktisch." },
            { title: "Mustertapete", description: "Mit Motiven oder Streifen." }
          ]
        },

        pricingSection: {
          title: "Kosten für Tapezierarbeiten in Köln",
          content: `Orientierungspreise:
- Raufaser tapezieren + streichen: ca. 14-20 € pro m²
- Vliestapete: ca. 16-25 € pro m²
- Mustertapete: ca. 22-35 € pro m²`
        }
      },

      faq: [
        { question: "Wie lange hält Raufasertapete?", answer: "15-20 Jahre bei guter Verarbeitung, mehrfach überstreichbar." },
        { question: "Muss die alte Tapete immer runter?", answer: "In den meisten Fällen ja." }
      ],

      meta: {
        title: "Tapezierarbeiten Köln | Raufaser & Vliestapete | FarbWelt",
        description: "Professionelle Tapezierarbeiten in Köln ✓ Raufaser ✓ Vliestapete ✓ Blasenfrei. Jetzt Termin buchen!",
        keywords: "Tapezierarbeiten Köln, Tapezieren Köln, Raufaser Köln"
      }
    },
    
    // Tapezierarbeiten Leverkusen
    leverkusen: {
      heroTitle: "Tapezierarbeiten Leverkusen – Professionell tapezieren",
      heroSubtitle: "Von Raufaser bis Vliestapete – wir tapezieren Ihre Räume in Leverkusen.",
      mainContent: {
        intro: `Tapeten verleihen Räumen Charakter. In Leverkusen tapezieren wir professionell – von Wiesdorf bis Opladen.`,
        pricingSection: { title: "Preise", content: `Raufaser + Anstrich: ca. 14-20 € pro m². Vliestapete: ca. 16-25 € pro m².` }
      },
      faq: [{ question: "Welche Tapeten?", answer: "Raufaser, Vlies, Muster – alles möglich." }],
      meta: { title: "Tapezierarbeiten Leverkusen | FarbWelt Service", description: "Tapezierarbeiten in Leverkusen ✓ Professionell.", keywords: "Tapezierarbeiten Leverkusen" }
    },
    
    // Tapezierarbeiten Monheim
    monheim: {
      heroTitle: "Tapezierarbeiten Monheim – Professionell & Sauber",
      heroSubtitle: "Tapezieren in Monheim am Rhein. Raufaser, Vlies und mehr.",
      mainContent: {
        intro: `Wir tapezieren professionell in Monheim-Mitte und Baumberg. Sauber und blasenfrei.`,
        pricingSection: { title: "Preise", content: `Ab ca. 14 € pro m² inkl. Anstrich.` }
      },
      faq: [{ question: "Alte Tapete entfernen?", answer: "Ja, inklusive." }],
      meta: { title: "Tapezierarbeiten Monheim | FarbWelt Service", description: "Tapezierarbeiten in Monheim ✓ Sauber.", keywords: "Tapezierarbeiten Monheim" }
    }
  },

  // Renovierung - P0 Service
  renovierung: {
    duesseldorf: {
      heroTitle: "Wohnungsrenovierung Düsseldorf – Komplett aus einer Hand",
      heroSubtitle: "Komplette Renovierung Ihrer Wohnung oder Ihres Hauses. Von der Planung bis zur besenreinen Übergabe – wir koordinieren alles für Sie.",

      mainContent: {
        intro: `Eine Renovierung ist immer ein kleines Abenteuer. Ob Sie eine neue Wohnung beziehen, nach Jahren eine Auffrischung wünschen oder Ihre Immobilie vor dem Verkauf aufwerten möchten – mit FarbWelt Service haben Sie einen erfahrenen Partner an Ihrer Seite. Wir übernehmen Ihre komplette Wohnungsrenovierung in Düsseldorf.

Die Vielfalt der Düsseldorfer Wohnlandschaft kennen wir aus hunderten Projekten. Von der kompakten Studentenbude in Flingern über die familiengerechte Altbauwohnung in Bilk bis zur repräsentativen Villa in Oberkassel – wir haben für jede Wohnsituation die passende Lösung.`,

        expertiseSection: {
          title: "Renovierung als Gesamtpaket",
          content: `Eine professionelle Renovierung ist mehr als Streichen und Tapezieren. Sie beginnt mit einer sorgfältigen Bestandsaufnahme: Was muss gemacht werden? In welcher Reihenfolge? Welche Materialien sind sinnvoll? Wir erstellen einen durchdachten Projektplan und koordinieren alle Arbeiten – so vermeiden Sie Verzögerungen und Ärger.

Unser Leistungsumfang bei einer Komplettrenovierung umfasst: Tapeten entfernen, Wände und Decken spachteln und streichen, Heizkörper und Türen lackieren, Böden abdecken und nach Abschluss reinigen. Auf Wunsch koordinieren wir auch weitere Gewerke wie Elektriker oder Bodenleger.

Die Düsseldorfer Altbauwohnungen erfordern oft besondere Aufmerksamkeit. Jahrzehntealte Tapetenschichten müssen entfernt, marode Putze saniert, historische Details bewahrt werden. Diese Erfahrung haben wir und setzen sie in jedem Projekt ein.`
        },

        packageSection: {
          title: "Unsere Renovierungs-Pakete",
          items: [
            {
              title: "Basis-Renovierung",
              description: "Wände und Decken streichen (auf vorhandener Tapete oder Putz). Ideal für frisch gestrichene Wohnungen, die nur eine Auffrischung brauchen."
            },
            {
              title: "Standard-Renovierung",
              description: "Tapeten entfernen, Wände/Decken spachteln und streichen oder neu tapezieren. Das beliebteste Paket für gründliche Erneuerung."
            },
            {
              title: "Premium-Renovierung",
              description: "Komplett-Service inkl. Lackierung von Türen, Türrahmen, Heizkörpern und Fensterbänken. Für ein rundum perfektes Ergebnis."
            },
            {
              title: "Express-Renovierung",
              description: "Schnelle Lösung bei Umzug oder Mieterwechsel. Innerhalb weniger Tage bezugsfertig."
            }
          ]
        },

        processSection: {
          title: "Der Renovierungs-Ablauf",
          steps: [
            {
              title: "Erstbesichtigung",
              description: "Wir erfassen den Ist-Zustand, besprechen Ihre Wünsche und erstellen einen Maßnahmenkatalog."
            },
            {
              title: "Angebot & Zeitplan",
              description: "Sie erhalten ein detailliertes Festpreisangebot mit verbindlichem Zeitplan."
            },
            {
              title: "Vorbereitung",
              description: "Am ersten Tag werden Böden und verbliebene Möbel abgedeckt, alte Tapeten entfernt."
            },
            {
              title: "Malerarbeiten",
              description: "Spachteln, Grundieren, Streichen – jeder Arbeitsschritt baut auf dem vorherigen auf."
            },
            {
              title: "Lackierarbeiten",
              description: "Bei Premium-Paketen: Aufarbeitung von Türen, Rahmen und Heizkörpern."
            },
            {
              title: "Endreinigung & Übergabe",
              description: "Wir räumen auf, reinigen und übergeben die Wohnung bezugsfertig."
            }
          ]
        },

        pricingSection: {
          title: "Kosten einer Wohnungsrenovierung in Düsseldorf",
          content: `Orientierungspreise für Komplettrenovierungen (Streichen aller Wände und Decken):

- **40-50 m² Wohnung**: ca. 1.500-3.000 € (Basis), 2.500-4.500 € (Standard)
- **60-80 m² Wohnung**: ca. 2.500-4.000 € (Basis), 4.000-6.500 € (Standard)
- **100+ m² Wohnung**: ca. 4.000-6.000 € (Basis), 6.000-10.000 € (Standard)

Altbauwohnungen mit hohen Decken liegen ca. 20-30% über diesen Preisen. Für ein verbindliches Angebot kommen wir gerne kostenfrei zu Ihnen.`
        },

        faq: [
          {
            question: "Wie lange dauert eine komplette Wohnungsrenovierung?",
            answer: "Eine 70-m²-Wohnung benötigt typischerweise 5-8 Arbeitstage für eine Standard-Renovierung. Bei Altbauten mit viel Vorarbeit entsprechend mehr."
          },
          {
            question: "Kann die Wohnung während der Renovierung bewohnt werden?",
            answer: "Bei kleineren Projekten ja, indem wir Raum für Raum arbeiten. Bei Komplettrenovierungen ist es oft praktischer, die Wohnung für einige Tage zu räumen."
          },
          {
            question: "Bieten Sie auch Renovierungen für Vermieter an?",
            answer: "Ja, wir arbeiten mit vielen Vermietern und Hausverwaltungen in Düsseldorf zusammen. Schnelle Abwicklung bei Mieterwechsel ist unser Spezialgebiet."
          },
          {
            question: "Was ist im Festpreis enthalten?",
            answer: "Alle besprochenen Leistungen, Material, Abdeckarbeiten und Endreinigung. Zusätzliche Wünsche werden separat besprochen und angeboten."
          },
          {
            question: "Koordinieren Sie auch andere Gewerke?",
            answer: "Ja, auf Wunsch koordinieren wir Elektriker, Bodenleger oder Sanitärfachleute. So haben Sie nur einen Ansprechpartner für Ihr gesamtes Projekt."
          }
        ],

        nearbyDistricts: ["Flingern", "Bilk", "Pempelfort", "Oberbilk", "Unterbilk", "Friedrichstadt"]
      },

      meta: {
        title: "Wohnungsrenovierung Düsseldorf | Komplett-Service | FarbWelt",
        description: "Komplette Wohnungsrenovierung in Düsseldorf ✓ Festpreise ✓ Alles aus einer Hand ✓ Termingerecht. Renovierung vom Profi. Jetzt Angebot anfordern!",
        keywords: "Wohnungsrenovierung Düsseldorf, Renovierung Düsseldorf, Wohnung renovieren lassen, Komplettrenovierung Düsseldorf"
      }
    },
    
    // Renovierung Dormagen
    dormagen: {
      heroTitle: "Wohnungsrenovierung Dormagen – Komplett aus einer Hand",
      heroSubtitle: "Komplette Renovierung Ihrer Wohnung oder Ihres Hauses. Von der Planung bis zur Übergabe – wir kümmern uns um alles.",

      mainContent: {
        intro: `Eine Renovierung ist immer ein kleines Abenteuer. Ob Sie eine neue Wohnung beziehen, nach Jahren eine Auffrischung wünschen oder Ihre Immobilie aufwerten möchten – mit FarbWelt Service haben Sie einen erfahrenen Partner an Ihrer Seite.

Die Vielfalt der Dormagener Wohnlandschaft kennen wir aus hunderten Projekten. Von der kompakten Wohnung in Nievenheim über das Einfamilienhaus in Horrem bis zur historischen Immobilie in Zons – wir haben für jede Situation die passende Lösung.`,

        expertiseSection: {
          title: "Renovierung als Gesamtpaket",
          content: `Eine professionelle Renovierung ist mehr als Streichen und Tapezieren. Sie beginnt mit sorgfältiger Bestandsaufnahme: Was muss gemacht werden? In welcher Reihenfolge? Wir erstellen einen Projektplan und koordinieren alle Arbeiten.

Unser Leistungsumfang: Tapeten entfernen, Wände und Decken spachteln und streichen, Heizkörper und Türen lackieren, Böden abdecken und reinigen.`
        },

        packageSection: {
          title: "Unsere Renovierungs-Pakete",
          items: [
            { title: "Basis-Renovierung", description: "Wände und Decken streichen auf vorhandenem Untergrund." },
            { title: "Standard-Renovierung", description: "Tapeten entfernen, spachteln und neu streichen oder tapezieren." },
            { title: "Premium-Renovierung", description: "Komplett-Service inkl. Türen, Rahmen und Heizkörper." },
            { title: "Express-Renovierung", description: "Schnelle Lösung bei Umzug." }
          ]
        },

        pricingSection: {
          title: "Kosten einer Wohnungsrenovierung in Dormagen",
          content: `Orientierungspreise:
- 40-50 m²: ca. 1.400-2.800 € (Basis), 2.400-4.200 € (Standard)
- 60-80 m²: ca. 2.300-3.800 € (Basis), 3.800-6.000 € (Standard)
Keine Anfahrtskosten in Dormagen!`
        }
      },

      faq: [
        { question: "Wie lange dauert eine komplette Renovierung?", answer: "70-m²-Wohnung: typischerweise 5-8 Arbeitstage." },
        { question: "Kann ich während der Renovierung wohnen bleiben?", answer: "Bei kleineren Projekten ja. Bei Komplettrenovierungen ist Räumen praktischer." },
        { question: "Bieten Sie auch für Vermieter an?", answer: "Ja, schnelle Abwicklung bei Mieterwechsel ist unser Spezialgebiet." }
      ],

      meta: {
        title: "Wohnungsrenovierung Dormagen | Komplett-Service | FarbWelt",
        description: "Komplette Wohnungsrenovierung in Dormagen ✓ Festpreise ✓ Alles aus einer Hand. Jetzt anfragen!",
        keywords: "Wohnungsrenovierung Dormagen, Renovierung Dormagen, Wohnung renovieren Dormagen"
      }
    },
    
    // Renovierung Köln
    koeln: {
      heroTitle: "Wohnungsrenovierung Köln – Komplett aus einer Hand",
      heroSubtitle: "Komplette Renovierung Ihrer Wohnung in der Domstadt. Von der Planung bis zur Übergabe – wir kümmern uns um alles.",

      mainContent: {
        intro: `Eine Renovierung ist immer ein kleines Abenteuer. Ob Altbauwohnung in der Südstadt, WG in Ehrenfeld oder Villa in Lindenthal – mit FarbWelt Service haben Sie einen erfahrenen Partner an Ihrer Seite.

Die Vielfalt der Kölner Wohnlandschaft kennen wir aus hunderten Projekten. Für jede Wohnsituation haben wir die passende Lösung.`,

        expertiseSection: {
          title: "Renovierung als Gesamtpaket",
          content: `Eine professionelle Renovierung ist mehr als Streichen und Tapezieren. Sie beginnt mit sorgfältiger Bestandsaufnahme: Was muss gemacht werden? In welcher Reihenfolge? Wir erstellen einen Projektplan und koordinieren alle Arbeiten.

Unser Leistungsumfang: Tapeten entfernen, Wände und Decken spachteln und streichen, Heizkörper und Türen lackieren, Böden abdecken und reinigen.`
        },

        packageSection: {
          title: "Unsere Renovierungs-Pakete",
          items: [
            { title: "Basis-Renovierung", description: "Wände und Decken streichen auf vorhandenem Untergrund." },
            { title: "Standard-Renovierung", description: "Tapeten entfernen, spachteln und neu streichen." },
            { title: "Premium-Renovierung", description: "Komplett-Service inkl. Türen, Rahmen und Heizkörper." }
          ]
        },

        pricingSection: {
          title: "Kosten einer Wohnungsrenovierung in Köln",
          content: `Orientierungspreise:
- 40-50 m²: ca. 1.400-2.800 € (Basis), 2.400-4.200 € (Standard)
- 60-80 m²: ca. 2.300-3.800 € (Basis), 3.800-6.000 € (Standard)
Keine Anfahrtskosten in Köln!`
        }
      },

      faq: [
        { question: "Wie lange dauert eine komplette Renovierung?", answer: "70-m²-Wohnung: typischerweise 5-8 Arbeitstage." },
        { question: "Kann ich während der Renovierung wohnen bleiben?", answer: "Bei kleineren Projekten ja. Bei Komplettrenovierungen ist Räumen praktischer." }
      ],

      meta: {
        title: "Wohnungsrenovierung Köln | Komplett-Service | FarbWelt",
        description: "Komplette Wohnungsrenovierung in Köln ✓ Festpreise ✓ Alles aus einer Hand. Jetzt anfragen!",
        keywords: "Wohnungsrenovierung Köln, Renovierung Köln, Wohnung renovieren Köln"
      }
    },
    
    // Renovierung Leverkusen
    leverkusen: {
      heroTitle: "Wohnungsrenovierung Leverkusen – Komplett-Service",
      heroSubtitle: "Komplette Renovierung in Leverkusen. Von der Planung bis zur Übergabe.",
      mainContent: {
        intro: `Renovierung aus einer Hand in Leverkusen. Wir kümmern uns um alles – termingerecht und sauber.`,
        packageSection: { title: "Pakete", items: [
          { title: "Basis", description: "Wände streichen" },
          { title: "Standard", description: "Tapeten + Streichen" },
          { title: "Premium", description: "Komplett inkl. Türen" }
        ]},
        pricingSection: { title: "Preise", content: `60-80 m²: ca. 2.300-6.000 € je nach Paket.` }
      },
      faq: [{ question: "Dauer?", answer: "70 m²: ca. 5-8 Tage." }],
      meta: { title: "Renovierung Leverkusen | FarbWelt Service", description: "Wohnungsrenovierung Leverkusen ✓ Komplett.", keywords: "Renovierung Leverkusen" }
    },
    
    // Renovierung Monheim
    monheim: {
      heroTitle: "Wohnungsrenovierung Monheim – Alles aus einer Hand",
      heroSubtitle: "Komplettrenovierung in Monheim am Rhein. Wir machen Ihre Wohnung neu.",
      mainContent: {
        intro: `Renovierung in Monheim – komplett und termingerecht. Für Einzug, Auszug oder zur Auffrischung.`,
        pricingSection: { title: "Preise", content: `Individuell nach Besichtigung. Keine Anfahrtskosten.` }
      },
      faq: [{ question: "Wie lange?", answer: "Je nach Umfang 3-8 Tage." }],
      meta: { title: "Renovierung Monheim | FarbWelt Service", description: "Wohnungsrenovierung Monheim ✓ Komplett.", keywords: "Renovierung Monheim" }
    }
  },

  // Wohnungsübergabe - P0 Service
  wohnungsuebergabe: {
    duesseldorf: {
      heroTitle: "Wohnungsübergabe Düsseldorf – Express-Renovierung bei Umzug",
      heroSubtitle: "Sie ziehen aus oder ein? Wir renovieren Ihre Wohnung schnell und zuverlässig – auch bei kurzfristigen Terminen.",

      mainContent: {
        intro: `Der Umzug steht bevor, aber die Wohnung muss noch renoviert werden? Die Übergabe ist in einer Woche und die Wände haben Dübellöcher? Keine Panik – mit unserem Express-Service für Wohnungsübergaben sind wir Ihr Retter in der Not. In Düsseldorf sind wir bekannt für schnelle, zuverlässige Renovierungen bei Mieterwechsel.

Als FarbWelt Service haben wir uns auf die besonderen Anforderungen bei Wohnungsübergaben spezialisiert. Wir wissen, dass bei Umzügen jeder Tag zählt – und arbeiten entsprechend effizient, ohne dabei an Qualität zu sparen.`,

        expertiseSection: {
          title: "Express-Renovierung: Schnell, aber gründlich",
          content: `Eine Wohnungsübergabe-Renovierung muss zwei Anforderungen erfüllen: Sie muss schnell gehen, und sie muss den Vermieter zufriedenstellen. Beides können wir garantieren. Unser eingespieltes Team arbeitet effizient und hat Erfahrung mit den typischen Anforderungen bei Wohnungsübergaben.

Was gehört zu einer Übergabe-Renovierung? In erster Linie: Wände und Decken müssen in einem einwandfreien Zustand sein. Dübellöcher werden verspachtelt, Abriebstellen überstrichen, bei Bedarf werden Wände komplett neu gestrichen. Auch kleinere Schäden wie Kratzer an Türrahmen oder verfärbte Fensterbänke können wir beheben.

Wir kennen die Erwartungen Düsseldorfer Vermieter und Hausverwaltungen. Die Wohnung muss bei Übergabe so aussehen, dass sie sofort neu vermietet werden kann. Diesen Zustand stellen wir her – schnell, sauber und zum fairen Preis.`
        },

        servicesSection: {
          title: "Leistungen bei Wohnungsübergabe",
          items: [
            {
              title: "Kleinreparaturen",
              description: "Dübellöcher verschließen, kleine Putzschäden ausbessern, Kratzer und Abriebstellen kaschieren."
            },
            {
              title: "Wände auffrischen",
              description: "Überstreichen in Weiß oder der vom Vermieter gewünschten Farbe. Oft reicht ein Anstrich."
            },
            {
              title: "Komplettanstrich",
              description: "Vollständiger Neuanstrich aller Wände und Decken bei stärkerem Renovierungsbedarf."
            },
            {
              title: "Türen & Rahmen",
              description: "Bei Bedarf: Nachlackieren von Türblättern, Zargen und Fensterbänken."
            },
            {
              title: "Endreinigung",
              description: "Optional: Grundreinigung der Wohnung für eine perfekte Übergabe."
            }
          ]
        },

        expressService: {
          title: "Unser Express-Service",
          content: `Bei uns bedeutet Express wirklich Express. Für dringende Projekte bieten wir:

- **Schnelle Terminvergabe**: Oft können wir innerhalb von 3-5 Werktagen starten
- **Effiziente Teams**: Bei Bedarf arbeiten mehrere Maler parallel
- **Flexible Zeiten**: Auch Wochenendarbeit ist nach Absprache möglich
- **Garantierte Fertigstellung**: Wir halten den vereinbarten Übergabetermin

Der Express-Service kostet keinen Aufpreis – wir berechnen nur die tatsächlich erbrachte Leistung. Allerdings sind kurzfristige Termine von unserer Auslastung abhängig. Je früher Sie anfragen, desto besser können wir planen.`
        },

        pricingSection: {
          title: "Kosten bei Wohnungsübergabe",
          content: `Die Kosten hängen vom Zustand der Wohnung ab:

- **Kleinreparaturen** (Dübellöcher, kleine Ausbesserungen): ab ca. 200-400 €
- **Auffrischungsanstrich** (1x streichen): ca. 6-10 € pro m² Wandfläche
- **Komplettrenovierung** (alle Wände/Decken): ca. 12-18 € pro m²

Typische Preisbeispiele:
- 40-m²-Wohnung, Auffrischung: ca. 800-1.200 €
- 60-m²-Wohnung, Komplett: ca. 1.800-2.800 €
- 80-m²-Wohnung, Komplett: ca. 2.400-3.600 €

Für eine schnelle Einschätzung schicken Sie uns gerne Fotos per WhatsApp oder E-Mail.`
        },

        faq: [
          {
            question: "Wie kurzfristig können Sie eine Wohnung renovieren?",
            answer: "Bei verfügbarer Kapazität können wir oft innerhalb von 3-5 Werktagen starten und eine Standardwohnung in 1-3 Tagen fertigstellen. Rufen Sie an – wir sagen Ihnen sofort, was möglich ist."
          },
          {
            question: "Muss ich beim Umzug alles weiß streichen?",
            answer: "Das hängt von Ihrem Mietvertrag ab. In der Regel müssen Sie die Wohnung in neutralen Farben übergeben. Farbige Wände sollten überstrichen werden. Im Zweifel klären Sie das mit Ihrem Vermieter."
          },
          {
            question: "Was passiert, wenn mein Vermieter nicht zufrieden ist?",
            answer: "Wir arbeiten so, dass Vermieter zufrieden sind. Sollte es dennoch Beanstandungen geben, beheben wir diese im Rahmen unserer Gewährleistung kostenfrei."
          },
          {
            question: "Kann ich auch nur Teilleistungen buchen?",
            answer: "Ja, Sie können auch nur einzelne Räume oder nur Kleinreparaturen buchen. Wir machen, was Sie brauchen."
          },
          {
            question: "Bieten Sie auch Endreinigung an?",
            answer: "Ja, wir können die Wohnung nach den Malerarbeiten grundreinigen. So ist alles aus einer Hand und Sie sparen Koordinationsaufwand."
          }
        ],

        nearbyDistricts: ["Flingern", "Bilk", "Oberbilk", "Pempelfort", "Derendorf", "Unterbilk"]
      },

      meta: {
        title: "Wohnungsübergabe Düsseldorf | Express-Renovierung | FarbWelt",
        description: "Schnelle Wohnungsrenovierung bei Übergabe in Düsseldorf ✓ Express-Service ✓ Kurzfristige Termine ✓ Faire Preise. Stressfrei umziehen!",
        keywords: "Wohnungsübergabe Düsseldorf, Wohnung streichen Umzug, Express Maler Düsseldorf, Auszugsrenovierung, Einzugsrenovierung"
      }
    },
    
    // Wohnungsübergabe Dormagen
    dormagen: {
      heroTitle: "Wohnungsübergabe Dormagen – Express-Renovierung bei Umzug",
      heroSubtitle: "Sie ziehen aus oder ein? Wir renovieren schnell und zuverlässig – auch bei kurzfristigen Terminen.",

      mainContent: {
        intro: `Der Umzug steht bevor, aber die Wohnung muss noch renoviert werden? Die Übergabe ist in einer Woche und die Wände haben Dübellöcher? Keine Panik – mit unserem Express-Service sind wir Ihr Retter in der Not.

Als FarbWelt Service haben wir uns auf die besonderen Anforderungen bei Wohnungsübergaben spezialisiert. Wir wissen, dass bei Umzügen jeder Tag zählt – und arbeiten entsprechend effizient.`,

        expertiseSection: {
          title: "Express-Renovierung: Schnell und gründlich",
          content: `Eine Wohnungsübergabe-Renovierung muss zwei Anforderungen erfüllen: Sie muss schnell gehen, und sie muss den Vermieter zufriedenstellen. Beides können wir garantieren.

Wir kennen die Erwartungen der Vermieter und Hausverwaltungen in Dormagen. Die Wohnung muss bei Übergabe so aussehen, dass sie sofort neu vermietet werden kann.`
        },

        servicesSection: {
          title: "Leistungen bei Wohnungsübergabe",
          items: [
            { title: "Kleinreparaturen", description: "Dübellöcher verschließen, Kratzer kaschieren." },
            { title: "Wände auffrischen", description: "Überstreichen in Weiß oder gewünschter Farbe." },
            { title: "Komplettanstrich", description: "Vollständiger Neuanstrich bei stärkerem Bedarf." },
            { title: "Türen & Rahmen", description: "Nachlackieren bei Bedarf." },
            { title: "Endreinigung", description: "Optional: Grundreinigung für perfekte Übergabe." }
          ]
        },

        pricingSection: {
          title: "Kosten bei Wohnungsübergabe in Dormagen",
          content: `Orientierungspreise:
- Kleinreparaturen: ab ca. 180-350 €
- Auffrischungsanstrich: ca. 6-9 € pro m²
- Komplettrenovierung: ca. 11-16 € pro m²
40-m²-Wohnung, Auffrischung: ca. 700-1.100 €
Für schnelle Einschätzung: Fotos per WhatsApp!`
        }
      },

      faq: [
        { question: "Wie kurzfristig können Sie renovieren?", answer: "Bei Kapazität oft innerhalb von 3-5 Werktagen." },
        { question: "Muss ich alles weiß streichen?", answer: "Das hängt vom Mietvertrag ab. Wir beraten Sie gerne." },
        { question: "Was bei Vermieter-Reklamation?", answer: "Wir arbeiten so, dass Vermieter zufrieden sind. Nachbesserung kostenfrei." }
      ],

      meta: {
        title: "Wohnungsübergabe Dormagen | Express-Renovierung | FarbWelt",
        description: "Schnelle Wohnungsrenovierung bei Übergabe in Dormagen ✓ Express-Service ✓ Kurzfristige Termine. Stressfrei umziehen!",
        keywords: "Wohnungsübergabe Dormagen, Express Maler Dormagen, Auszugsrenovierung Dormagen"
      }
    },
    
    // Wohnungsübergabe Köln
    koeln: {
      heroTitle: "Wohnungsübergabe Köln – Express-Renovierung bei Umzug",
      heroSubtitle: "Sie ziehen aus oder ein? Wir renovieren schnell und zuverlässig in der Domstadt – auch bei kurzfristigen Terminen.",

      mainContent: {
        intro: `Der Umzug steht bevor, aber die Wohnung muss noch renoviert werden? Keine Panik – mit unserem Express-Service sind wir Ihr Retter in der Not. In Köln sind wir bekannt für schnelle, zuverlässige Renovierungen bei Mieterwechsel.

Als FarbWelt Service wissen wir, dass bei Umzügen jeder Tag zählt – und arbeiten entsprechend effizient.`,

        expertiseSection: {
          title: "Express-Renovierung: Schnell und gründlich",
          content: `Eine Wohnungsübergabe-Renovierung muss zwei Anforderungen erfüllen: Sie muss schnell gehen, und sie muss den Vermieter zufriedenstellen. Beides können wir garantieren.

Wir kennen die Erwartungen der Kölner Vermieter und Hausverwaltungen. Die Wohnung muss bei Übergabe so aussehen, dass sie sofort neu vermietet werden kann.`
        },

        servicesSection: {
          title: "Leistungen bei Wohnungsübergabe",
          items: [
            { title: "Kleinreparaturen", description: "Dübellöcher verschließen, Kratzer kaschieren." },
            { title: "Wände auffrischen", description: "Überstreichen in Weiß oder gewünschter Farbe." },
            { title: "Komplettanstrich", description: "Vollständiger Neuanstrich bei stärkerem Bedarf." }
          ]
        },

        pricingSection: {
          title: "Kosten bei Wohnungsübergabe in Köln",
          content: `Orientierungspreise:
- Kleinreparaturen: ab ca. 180-350 €
- Auffrischungsanstrich: ca. 6-9 € pro m²
- Komplettrenovierung: ca. 11-16 € pro m²
Für schnelle Einschätzung: Fotos per WhatsApp!`
        }
      },

      faq: [
        { question: "Wie kurzfristig können Sie renovieren?", answer: "Bei Kapazität oft innerhalb von 3-5 Werktagen." },
        { question: "Bieten Sie auch Wochenendarbeit?", answer: "In dringenden Fällen ja." }
      ],

      meta: {
        title: "Wohnungsübergabe Köln | Express-Renovierung | FarbWelt",
        description: "Schnelle Wohnungsrenovierung bei Übergabe in Köln ✓ Express-Service ✓ Kurzfristige Termine. Stressfrei umziehen!",
        keywords: "Wohnungsübergabe Köln, Express Maler Köln, Auszugsrenovierung Köln"
      }
    },
    
    // Wohnungsübergabe Leverkusen
    leverkusen: {
      heroTitle: "Wohnungsübergabe Leverkusen – Express-Renovierung",
      heroSubtitle: "Schnelle Renovierung bei Umzug in Leverkusen. Auch kurzfristig.",
      mainContent: {
        intro: `Der Umzug steht bevor? Wir renovieren schnell und zuverlässig – in Wiesdorf, Opladen und allen Stadtteilen.`,
        pricingSection: { title: "Preise", content: `Kleinreparaturen: ab 180 €. Auffrischung: ca. 6-9 € pro m².` }
      },
      faq: [{ question: "Wie kurzfristig?", answer: "Oft innerhalb von 3-5 Werktagen." }],
      meta: { title: "Wohnungsübergabe Leverkusen | FarbWelt Service", description: "Express-Renovierung Leverkusen ✓ Schnell.", keywords: "Wohnungsübergabe Leverkusen" }
    },
    
    // Wohnungsübergabe Monheim
    monheim: {
      heroTitle: "Wohnungsübergabe Monheim – Express-Service",
      heroSubtitle: "Schnelle Renovierung bei Umzug in Monheim am Rhein.",
      mainContent: {
        intro: `Keine Zeit? Wir renovieren Express. In Monheim-Mitte und Baumberg schnell und zuverlässig.`,
        pricingSection: { title: "Preise", content: `Auffrischung: ab ca. 6 € pro m². Kleinreparaturen: ab 180 €.` }
      },
      faq: [{ question: "Wochenende?", answer: "Bei Bedarf möglich." }],
      meta: { title: "Wohnungsübergabe Monheim | FarbWelt Service", description: "Express-Renovierung Monheim ✓ Schnell.", keywords: "Wohnungsübergabe Monheim" }
    }
  },

  // Lackierarbeiten - P1 Service
  lackierarbeiten: {
    duesseldorf: {
      heroTitle: "Lackierarbeiten Düsseldorf – Türen, Fenster & Heizkörper",
      heroSubtitle: "Professionelle Lackierung für ein perfektes Finish. Wir lackieren Türen, Rahmen, Fenster, Heizkörper und mehr.",

      mainContent: {
        intro: `Lackierarbeiten sind die Königsdisziplin der Malerarbeit. Eine perfekt lackierte Tür, ein makellos glatter Fensterrahmen, ein strahlend weißer Heizkörper – das sind Details, die den Unterschied machen zwischen einer renovierten und einer perfekt renovierten Wohnung. In Düsseldorf sind wir als FarbWelt Service Ihr Spezialist für anspruchsvolle Lackierarbeiten.

Lackieren erfordert Erfahrung, Geduld und das richtige Werkzeug. Anders als beim Wandanstrich sieht man jede Ungenauigkeit sofort – Läufer, Orangenhaut, unsaubere Kanten. Unsere Maler beherrschen die Techniken für ein glattes, gleichmäßiges Ergebnis.`,

        expertiseSection: {
          title: "Lackier-Know-how für Düsseldorf",
          content: `In den Düsseldorfer Altbauwohnungen gibt es oft noch historische Holztüren, Kassettentüren und massive Türrahmen. Diese Elemente sind häufig wertvoll und verdienen eine fachgerechte Behandlung. Wir können alte Lacke schonend entfernen, das Holz aufarbeiten und mit hochwertigen Lacken neu beschichten.

Moderne Türen aus Kunststoff oder mit Folienbeschichtung erfordern andere Techniken. Hier verwenden wir spezielle Haftgrundierungen und Lacke, die auf diesen Untergründen dauerhaft halten. Das Ergebnis: ein frisches Erscheinungsbild ohne Austausch der gesamten Tür.

Auch Heizkörper sind ein wichtiges Thema. Alte Radiatoren mit abblätterndem Lack sehen nicht nur unschön aus – sie rosten auch. Wir schleifen alte Lacke ab, behandeln Roststellen und lackieren mit hitzebeständigem Lack. So sehen Ihre Heizkörper wieder aus wie neu.`
        },

        servicesSection: {
          title: "Unser Lackier-Leistungsspektrum",
          items: [
            {
              title: "Türen lackieren",
              description: "Zimmertüren, Haustüren, Kellertüren – wir lackieren alle Türarten mit dem passenden System."
            },
            {
              title: "Türrahmen & Zargen",
              description: "Oft vernachlässigt, aber wichtig: sauber lackierte Rahmen runden das Gesamtbild ab."
            },
            {
              title: "Fenster lackieren",
              description: "Holzfenster innen und außen. Wir verwenden wetterbeständige Lacke für die Außenseite."
            },
            {
              title: "Heizkörper lackieren",
              description: "Alte Radiatoren aufarbeiten oder neue farblich anpassen. Mit hitzebeständigem Speziallack."
            },
            {
              title: "Fensterbänke",
              description: "Holz- und Kunststoff-Fensterbänke lackieren oder auffrischen."
            },
            {
              title: "Treppen & Geländer",
              description: "Treppengeländer, Handläufe und Stufen – wir lackieren auch komplexere Bauteile."
            }
          ]
        },

        processSection: {
          title: "So läuft eine professionelle Lackierung ab",
          steps: [
            {
              title: "Vorbereitung",
              description: "Schleifen des alten Lacks, Entfetten, Abkleben der Umgebung. Bei Bedarf Abbeizen alter Lackschichten."
            },
            {
              title: "Grundierung",
              description: "Haftgrund auftragen für optimale Verbindung zwischen Untergrund und Lack."
            },
            {
              title: "Zwischenschliff",
              description: "Leichtes Anschleifen nach dem Grundieren für eine perfekt glatte Oberfläche."
            },
            {
              title: "Lackauftrag",
              description: "Auftrag des Endlacks in ein bis zwei Schichten, je nach gewünschter Deckung und Oberfläche."
            },
            {
              title: "Trocknung & Kontrolle",
              description: "Ausreichende Trocknungszeit, dann Kontrolle und eventuelle Nachbesserung."
            }
          ]
        },

        pricingSection: {
          title: "Kosten für Lackierarbeiten in Düsseldorf",
          content: `Die Kosten hängen von Größe, Zustand und Anzahl der Elemente ab:

- **Zimmertür lackieren** (Blatt + Rahmen): ca. 150-250 € pro Tür
- **Kassettentür** (aufwendiger): ca. 200-350 € pro Tür
- **Heizkörper lackieren**: ca. 80-150 € pro Heizkörper
- **Fenster lackieren**: ca. 100-200 € pro Fenster (innen)
- **Fensterbank lackieren**: ca. 30-60 € pro Stück

Bei umfangreichen Lackierarbeiten (z.B. alle Türen einer Wohnung) bieten wir Paketpreise an.`
        },

        faq: [
          {
            question: "Wie lange muss lackierte Farbe trocknen?",
            answer: "Je nach Lacktyp ist die Oberfläche nach 2-4 Stunden staubtrocken, nach 24 Stunden belastbar. Vollständig ausgehärtet ist der Lack nach etwa 7 Tagen."
          },
          {
            question: "Können Sie auch farbig lackieren?",
            answer: "Ja, wir lackieren in jeder RAL-Farbe oder nach Farbmuster. Farbige Türen oder Akzente sind ein schönes Gestaltungselement."
          },
          {
            question: "Lohnt sich das Lackieren alter Türen?",
            answer: "Oft ja! Besonders massive Holztüren und Kassettentüren sind hochwertig und können durch Lackieren wieder wie neu aussehen – günstiger als ein Austausch."
          },
          {
            question: "Wie riecht es nach dem Lackieren?",
            answer: "Moderne wasserbasierte Lacke riechen deutlich weniger als früher. Trotzdem empfehlen wir, nach dem Lackieren gut zu lüften. Nach 1-2 Tagen ist der Geruch verschwunden."
          },
          {
            question: "Können Sie auch Einbauschränke lackieren?",
            answer: "Ja, wir können auch Einbauschränke, Küchenfronten und andere Möbeloberflächen lackieren. Sprechen Sie uns auf Ihr Projekt an."
          }
        ],

        nearbyDistricts: ["Pempelfort", "Oberkassel", "Kaiserswerth", "Bilk", "Flingern", "Carlstadt"]
      },

      meta: {
        title: "Lackierarbeiten Düsseldorf | Türen & Fenster lackieren | FarbWelt",
        description: "Professionelle Lackierarbeiten in Düsseldorf ✓ Türen ✓ Fenster ✓ Heizkörper ✓ Perfektes Finish. Lackieren vom Fachmann!",
        keywords: "Lackierarbeiten Düsseldorf, Türen lackieren Düsseldorf, Fenster lackieren, Heizkörper lackieren, Maler Lackierung"
      }
    },
    
    // Dormagen - Lackierarbeiten
    dormagen: {
      heroTitle: "Lackierarbeiten Dormagen – Türen, Fenster & Heizkörper",
      heroSubtitle: "Professionelle Lackierung für ein perfektes Finish. Wir lackieren präzise und sauber.",

      mainContent: {
        intro: `Lackierarbeiten sind die Königsdisziplin der Malerarbeit. Eine perfekt lackierte Tür, ein makellos glatter Fensterrahmen, ein strahlend weißer Heizkörper – das sind Details, die den Unterschied machen. In Dormagen sind wir als FarbWelt Service Ihr Spezialist für anspruchsvolle Lackierarbeiten.

Lackieren erfordert Erfahrung, Geduld und das richtige Werkzeug. Anders als beim Wandanstrich sieht man jede Ungenauigkeit sofort – Läufer, Orangenhaut, unsaubere Kanten. Unsere Maler beherrschen die Techniken für ein gleichmäßiges Ergebnis.`,

        expertiseSection: {
          title: "Lackier-Know-how für Dormagen",
          content: `In den älteren Häusern von Dormagen gibt es oft noch originale Holztüren und massive Türrahmen. Diese Elemente sind häufig wertvoll und verdienen eine fachgerechte Behandlung. Wir können alte Lacke entfernen, das Holz aufarbeiten und mit hochwertigen Lacken neu beschichten.

Besonders in Zons finden sich historische Türen und Fenster, die restauriert werden sollten statt ausgetauscht zu werden. Hier arbeiten wir mit traditionellen Techniken und hochwertigen Lacksystemen, die zum Charakter der Gebäude passen.

Auch Heizkörper sind ein wichtiges Thema. Alte Radiatoren mit abblätterndem Lack sehen nicht nur unschön aus – sie rosten auch. Wir schleifen alte Lacke ab, behandeln Roststellen und lackieren mit hitzebeständigem Lack.`
        },

        servicesSection: {
          title: "Unser Lackier-Leistungsspektrum",
          items: [
            { title: "Türen lackieren", description: "Zimmertüren, Haustüren, Kellertüren – alle Türarten mit dem passenden System." },
            { title: "Türrahmen & Zargen", description: "Sauber lackierte Rahmen runden das Gesamtbild ab." },
            { title: "Fenster lackieren", description: "Holzfenster innen und außen mit wetterbeständigen Lacken." },
            { title: "Heizkörper lackieren", description: "Alte Radiatoren aufarbeiten mit hitzebeständigem Speziallack." },
            { title: "Fensterbänke", description: "Holz- und Kunststoff-Fensterbänke lackieren oder auffrischen." },
            { title: "Treppen & Geländer", description: "Treppengeländer, Handläufe und Stufen professionell lackieren." }
          ]
        },

        processSection: {
          title: "So läuft eine professionelle Lackierung ab",
          steps: [
            { title: "Vorbereitung", description: "Schleifen des alten Lacks, Entfetten, sorgfältiges Abkleben der Umgebung." },
            { title: "Grundierung", description: "Haftgrund auftragen für optimale Verbindung." },
            { title: "Zwischenschliff", description: "Leichtes Anschleifen für perfekt glatte Oberfläche." },
            { title: "Lackauftrag", description: "Endlack in ein bis zwei Schichten für perfekte Deckung." },
            { title: "Trocknung & Kontrolle", description: "Ausreichende Trocknungszeit, Kontrolle und eventuelle Nachbesserung." }
          ]
        },

        pricingSection: {
          title: "Kosten für Lackierarbeiten in Dormagen",
          content: `Die Kosten hängen von Größe und Zustand ab:

- **Zimmertür lackieren** (Blatt + Rahmen): ca. 140-230 € pro Tür
- **Kassettentür** (aufwendiger): ca. 180-320 € pro Tür
- **Heizkörper lackieren**: ca. 70-140 € pro Heizkörper
- **Fenster lackieren**: ca. 90-180 € pro Fenster

Bei umfangreichen Lackierarbeiten bieten wir Paketpreise an.`
        }
      },

      faq: [
        { question: "Wie lange muss lackierte Farbe trocknen?", answer: "Nach 2-4 Stunden staubtrocken, nach 24 Stunden belastbar. Vollständig ausgehärtet nach etwa 7 Tagen." },
        { question: "Können Sie auch farbig lackieren?", answer: "Ja, wir lackieren in jeder RAL-Farbe. Farbige Türen sind ein schönes Gestaltungselement." },
        { question: "Lohnt sich das Lackieren alter Türen?", answer: "Oft ja! Besonders massive Holztüren können durch Lackieren wieder wie neu aussehen – günstiger als ein Austausch." },
        { question: "Arbeiten Sie auch an historischen Türen in Zons?", answer: "Ja, wir haben Erfahrung mit der Restaurierung historischer Holzelemente." }
      ],

      meta: {
        title: "Lackierarbeiten Dormagen | Türen & Fenster lackieren | FarbWelt",
        description: "Professionelle Lackierarbeiten in Dormagen ✓ Türen ✓ Fenster ✓ Heizkörper. Perfektes Finish vom Fachmann!",
        keywords: "Lackierarbeiten Dormagen, Türen lackieren Dormagen, Fenster lackieren Dormagen"
      }
    },
    
    // Lackierarbeiten Köln
    koeln: {
      heroTitle: "Lackierarbeiten Köln – Türen, Fenster & Heizkörper",
      heroSubtitle: "Professionelle Lackierung in der Domstadt für ein perfektes Finish. Wir lackieren präzise und sauber.",

      mainContent: {
        intro: `Lackierarbeiten sind die Königsdisziplin der Malerarbeit. Eine perfekt lackierte Tür, ein makellos glatter Fensterrahmen – das sind Details, die den Unterschied machen. In Köln sind wir als FarbWelt Service Ihr Spezialist.

Lackieren erfordert Erfahrung, Geduld und das richtige Werkzeug. Anders als beim Wandanstrich sieht man jede Ungenauigkeit sofort – Läufer, Orangenhaut, unsaubere Kanten. Unsere Maler beherrschen die Techniken.`,

        expertiseSection: {
          title: "Lackier-Know-how für Köln",
          content: `In den Kölner Altbauten gibt es oft noch originale Holztüren und massive Türrahmen. Diese verdienen eine fachgerechte Behandlung. Besonders im Belgischen Viertel und der Südstadt finden sich wertvolle historische Türen.

Auch Heizkörper sind wichtig. Alte Radiatoren mit abblätterndem Lack sehen nicht nur unschön aus – sie rosten auch. Wir lackieren mit hitzebeständigem Speziallack.`
        },

        servicesSection: {
          title: "Unser Lackier-Leistungsspektrum",
          items: [
            { title: "Türen lackieren", description: "Zimmertüren, Haustüren, Kellertüren." },
            { title: "Türrahmen & Zargen", description: "Sauber lackierte Rahmen für ein perfektes Bild." },
            { title: "Heizkörper lackieren", description: "Alte Radiatoren aufarbeiten mit hitzebeständigem Lack." },
            { title: "Fenster lackieren", description: "Holzfenster innen und außen." }
          ]
        },

        pricingSection: {
          title: "Kosten für Lackierarbeiten in Köln",
          content: `Orientierungspreise:
- Zimmertür lackieren (Blatt + Rahmen): ca. 140-230 € pro Tür
- Kassettentür (aufwendiger): ca. 180-320 € pro Tür
- Heizkörper lackieren: ca. 70-140 € pro Heizkörper`
        }
      },

      faq: [
        { question: "Wie lange muss lackierte Farbe trocknen?", answer: "Nach 2-4 Stunden staubtrocken, nach 24 Stunden belastbar." },
        { question: "Können Sie auch farbig lackieren?", answer: "Ja, wir lackieren in jeder RAL-Farbe." }
      ],

      meta: {
        title: "Lackierarbeiten Köln | Türen & Fenster lackieren | FarbWelt",
        description: "Professionelle Lackierarbeiten in Köln ✓ Türen ✓ Fenster ✓ Heizkörper. Perfektes Finish vom Fachmann!",
        keywords: "Lackierarbeiten Köln, Türen lackieren Köln, Fenster lackieren Köln"
      }
    },
    
    // Lackierarbeiten Leverkusen
    leverkusen: {
      heroTitle: "Lackierarbeiten Leverkusen – Türen, Fenster & Heizkörper",
      heroSubtitle: "Professionelle Lackierung in Leverkusen. Perfektes Finish.",
      mainContent: {
        intro: `Lackierarbeiten sind Präzisionsarbeit. Wir lackieren Türen, Fenster und Heizkörper in allen Leverkusener Stadtteilen.`,
        pricingSection: { title: "Preise", content: `Zimmertür: ca. 140-230 €. Heizkörper: ca. 70-140 €.` }
      },
      faq: [{ question: "Farbig lackieren?", answer: "Ja, alle RAL-Farben möglich." }],
      meta: { title: "Lackierarbeiten Leverkusen | FarbWelt Service", description: "Lackierarbeiten in Leverkusen ✓ Präzise.", keywords: "Lackierarbeiten Leverkusen" }
    },
    
    // Lackierarbeiten Monheim
    monheim: {
      heroTitle: "Lackierarbeiten Monheim – Perfektes Finish",
      heroSubtitle: "Professionelle Lackierung in Monheim am Rhein.",
      mainContent: {
        intro: `Türen, Fenster und Heizkörper professionell lackiert. In Monheim-Mitte und Baumberg.`,
        pricingSection: { title: "Preise", content: `Zimmertür: ca. 140-230 €.` }
      },
      faq: [{ question: "Alte Türen aufarbeiten?", answer: "Ja, lohnt sich oft mehr als Neukauf." }],
      meta: { title: "Lackierarbeiten Monheim | FarbWelt Service", description: "Lackierarbeiten in Monheim ✓ Perfekt.", keywords: "Lackierarbeiten Monheim" }
    }
  }
};

// Helper function to get service content for a specific city
export const getServiceContent = (serviceSlug, citySlug) => {
  const serviceData = serviceContent[serviceSlug];
  if (!serviceData) return null;
  return serviceData[citySlug] || null;
};

export default serviceContent;
